import ajaxRequest from "@/utils/ajaxRequest.js";

export default function (element, data) {
  let payload = {};
  const threshold = parseInt(data.threshold);
  let score = 0;

  const screens = Array.from(element.querySelectorAll('.test-screen'));

  function showScreen(screen) {
    screens.forEach(s => s.classList.remove('current'));
    screen.classList.add('current');
  }

  function showResult() {
    const result = score >= threshold
      ? 'danger'
      : 'safe';

    const resultScreen = element.querySelector('.test-screen-' + result);

    payload.resultValue = result;
    payload.result = resultScreen.querySelector('.result-title').textContent.trim();
    payload.resultText = resultScreen.querySelector('.result-text').textContent.trim();

    showScreen(resultScreen);
    ajaxRequest("/_ajax/test", payload);
  }

  function reset() {
    score = 0;
    payload = {};
    showScreen(element.querySelector('.test-screen-intro'));
  }

  // Кнопка «Начать тест»
  element.querySelector('.test-intro-button').addEventListener('click', () => {
    const firstQuestion = element.querySelector('.test-screen-question');
    showScreen(firstQuestion);
  });

  // Ответы на вопросы
  const questionScreens = Array.from(element.querySelectorAll('.test-screen-question'));
  questionScreens.forEach((screen, index) => {
    const questionText = screen.querySelector('.question-text').textContent.trim();

    screen.querySelectorAll('.answer').forEach(btn => {
      btn.addEventListener('click', () => {
        if (!payload.answers) payload.answers = [];
        payload.answers[index] = { question: questionText, answer: btn.textContent.trim() };

        score += parseInt(btn.dataset.value);
        const next = questionScreens[index + 1];
        if (next) {
          showScreen(next);
        } else {
          showResult();
        }
      });
    });
  });

  // Кнопки «Пройти повторно»
  element.querySelectorAll('.reset-button').forEach(btn => {
    btn.addEventListener('click', reset);
  });
}
